import {
  ContactDetailsStep,
  EligibilityFormStep,
  LicenseDetailsStep
} from '../../../../components'
import {
  getSelfEnrollmentDisplayStep,
  SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS,
  SELF_ENROLLMENT_STEPS
} from '../../utils/steps'
import type { FlowStepRendererProps } from './types'

type EntryStepProps = Pick<
  FlowStepRendererProps,
  | 'currentStep'
  | 'fieldEditability'
  | 'formData'
  | 'updateFormData'
  | 'enrollmentState'
  | 'navigation'
>

export function renderEntryStep({
  currentStep,
  fieldEditability,
  formData,
  updateFormData,
  enrollmentState,
  navigation
}: EntryStepProps) {
  switch (currentStep) {
    case SELF_ENROLLMENT_STEPS.ELIGIBILITY:
      return (
        <EligibilityFormStep
          currentStep={getSelfEnrollmentDisplayStep(currentStep)}
          totalSteps={SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS}
          fieldEditability={fieldEditability}
          formData={formData}
          updateFormData={updateFormData}
          onBack={navigation.resetAnonymousEnrollmentAndReturnToOptions}
          onContinue={enrollmentState.handleEligibilityContinue}
          isSubmitting={enrollmentState.submitEnrollmentStepPending}
          errorMessage={enrollmentState.stepSubmissionError}
        />
      )
    case SELF_ENROLLMENT_STEPS.LICENSE_DETAILS:
      return (
        <LicenseDetailsStep
          currentStep={getSelfEnrollmentDisplayStep(currentStep)}
          totalSteps={SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS}
          fieldEditability={fieldEditability}
          formData={formData}
          updateFormData={updateFormData}
          onBack={enrollmentState.handleBack}
          onContinue={enrollmentState.handleLicenseDetailsContinue}
          isSubmitting={enrollmentState.submitEnrollmentStepPending}
          errorMessage={enrollmentState.stepSubmissionError}
        />
      )
    case SELF_ENROLLMENT_STEPS.CONTACT_DETAILS:
      return (
        <ContactDetailsStep
          currentStep={getSelfEnrollmentDisplayStep(currentStep)}
          totalSteps={SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS}
          fieldEditability={fieldEditability}
          formData={formData}
          updateFormData={updateFormData}
          onBack={enrollmentState.handleBack}
          onContinue={enrollmentState.handleContactDetailsContinue}
          isSubmitting={enrollmentState.submitEnrollmentStepPending}
          errorMessage={enrollmentState.stepSubmissionError}
        />
      )
    default:
      return null
  }
}
